import React from 'react'
import {API_BASE_URL} from '../../constants'
import axios from 'axios'
import ReactTable  from "react-table";
import {getToken} from '../../storage'
import {NotificationManager} from 'react-notifications'

import {Loader} from '../../utils/misc'
import CI from '../../utils/calendar'
import DateFormat from '../../utils/dateformat'
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import moment from 'moment'

export default class SectionPayment extends React.Component {

  constructor(props){
    super(props)
    this.handleReloadPayments = this.handleReloadPayments.bind(this)
    this.state = {showPaymentList:true}
  }

  handleReloadPayments() {
    this.setState({showPaymentList:false})
    this.setState({showPaymentList:true})
  }

  render() {

    let purchase = this.props.purchase
    console.log("Payment ", purchase);
    let addpayment = <AddPayment purchase={purchase} onAddCallback={this.handleReloadPayments} />
    let paymentlist

    if(this.state.showPaymentList) {
      paymentlist = <PaymentList purchase={purchase} />
    }

    return <div>
      <section className="medium">
        <h4>Add Payment</h4>
      </section>
      <div className="row">
      <div className="col-md-12">
        {addpayment}
      </div>


      </div>
      <section className="small">
        <h4>Payments</h4>
        <div className="row">
          <div className="col-md-12">
            {paymentlist}
          </div>
        </div>
      </section>
      </div>

  }
}

class AddPayment extends React.Component {

  constructor(props) {
    super(props)
    this.state = { payment: {mode:"cash", amount:"", date_ui: moment(new Date()).format('YYYY-MM-DD'),  date: moment(new Date()).format(), notes:"", reference:"", purchase:this.props.purchase}, loading:true}
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleDateChange = this.handleDateChange.bind(this)
    this.submit = this.submit.bind(this)
    this.getPayment = this.getPayment.bind(this)

  }

  componentDidMount() {


    if(typeof this.props.match !=="undefined" && typeof this.props.match.params.payment_id !== "undefined") {
      this.setState({mode:'edit'})
      this.getPayment(this.props.match.params.payment_id).then((response)=>{
        if(response.status===200) {
          this.setState({payment: response.data.payment, loading:false})
        }
      }).catch((err)=>{
        this.setState({loading:false})
      })
    }

    else {
        this.setState({loading:false})
    }

  }

  getPayment(payment_id) {
    return axios({
      url: '/get_payment/?id='+payment_id,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }

  submit() {
    this.setState({submitting:true})


    let apiurl
    if(this.state.mode ==="edit") {
      apiurl  = "/update_payment/"
    }
    else {
      apiurl  = "/create_new_payment/"
    }

    axios({
      url: apiurl,
      method: 'post',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        },
        post: {
          'Content-Type': 'multipart/form-data;'
        }
      },
      data: this.state.payment
    }).then((response)=> {
      if(response.status === 200) {

        this.setState({payment:response.data.payment, submitting:false})
        if(typeof this.props.onAddCallback !== "undefined") {
        this.props.onAddCallback(response.data.payment)
        }
        else {

          if(this.state.mode==="edit") {
            NotificationManager.success("Updated Payment successfully")
          }
          else {
            NotificationManager.success("Created Payment successfully")
          }

        }

      }
    }).catch((err)=> {
      console.log(err);
    })

  }

  handleInputChange(e) {
    var name = e.target.name
    var value = e.target.value
    let payment = this.state.payment
    payment[name] = value
    this.setState({payment:payment})
  }

  handleDateChange(date) {
    let payment = this.state.payment

    payment['date_ui'] = moment(date).format('YYYY-MM-DD')
    payment['date'] = moment(date).format()
    this.setState({payment:payment})
  }

  render() {

    let submitButton = <button className="btn btn-success" onClick={this.submit}>Save</button>
    if(this.state.submitting) {
      submitButton = <button className="btn btn-success" disabled>Saving..</button>
    }

    if(this.state.loading) {
      return <Loader />
    }
    else {

        let payment = this.state.payment
        // let pageHeader
        // if(this.state.mode == "edit") {
        //   pageHeader = <h3>{"Edit Payment  #" + payment.serial}</h3>
        // }
        // else {
        //   pageHeader =  <h3 >Add Payment</h3>
        // }

      return <div>

          <div className="form-horizontal">
              <div className="form-group">

                <div className="col-sm-6">
                Amount
                <input  type="text" name="amount" value={payment.amount} onChange={this.handleInputChange} className="form-control input-sm" required />
                </div>

                <div className="col-sm-6">
                Payment Mode
                <select name="mode" value={payment.mode} className="form-control input-sm" onChange={this.handleInputChange}>
                  <option value="cash" >CASH</option>
                  <option value="card">CARD</option>
                  <option value="cheque">CHEQUE</option>
                  <option value="banktransfer">BANK TRANSFER</option>
                  <option value="others">Others</option>
                </select>
                </div>
              </div>

              <div className="form-group">
              <div className="col-sm-6">
              Date
              <CI applyDate={this.handleDateChange} date={payment.date_ui} />
              </div>

              <div className="col-sm-6">
              Reference
              <input  type="text" name="reference" value={payment.reference} onChange={this.handleInputChange} className="form-control input-sm" />
              </div>
              </div>

              <div className="form-group">
               <div className="col-sm-12">
               Notes
                <textarea name="notes" className="form-control input-sm" value={payment.notes} onChange={this.handleInputChange}></textarea>
               </div>
              </div>

                <div className="form-action-group text-center">
                    {submitButton}
              </div>
      </div></div>
    }


  }
}



class PaymentList extends React.Component {


  constructor() {
    super();
    this.state = {
      tableState: {},
      data: [],
      pages: null,
      loading: true
    };
    this.fetchList = this.fetchList.bind(this)
    this.fetchData = this.fetchData.bind(this);
    this.deletePayment = this.deletePayment.bind(this)
    this.deleteFormat = this.deleteFormat.bind(this)
  }

    deletePayment(payment_id) {

      axios({
        url: '/delete_payment/',
        baseURL: API_BASE_URL,
        method:'post',
        data: {id:payment_id},
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      }).then(res => {
        this.fetchList()
      }).catch(err=>{
        console.log(err);
      })
    }

    fetchList(state=this.state.tableState) {

      this.setState({ loading: true });
      let apiurl = "/list_payments/?purchase="+this.props.purchase+'&page=' + state.page + '&page_size='+state.pageSize;
      if(typeof state.sorted !== "undefined" && state.sorted.length > 0) {
          apiurl = apiurl + '&sort_column='+state.sorted[0]['id']
          apiurl = apiurl + '&sort_dir='+state.sorted[0]['desc']
      }
      axios({
        url: apiurl,
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      }).then(res => {
        this.setState({
          data: res.data.payments,
          pages: res.data.pages,
          loading: false
        });
      });

    }

    fetchData(state, instance) {
      this.fetchList(state)
      this.setState({tableState: state})
    }

    deleteFormat(row) {
      return <button className="btn btn-sm btn-danger" onClick={e=>this.deletePayment(row.original.id)}>Delete</button>
    }


    render() {

      const { data, pages, loading } = this.state;
      const columns = [
        {Header:'Date',  accessor:'date',sortable:false,  Cell:(row)=>(<DateFormat date={row.original.date}/>)},
        {Header:'Amount',  accessor:'amount',sortable:true},
        {Header:'Mode', accessor: 'mode',sortable:false },
        {Header:'Reference', accessor: 'reference',sortable:false },
        {Header:'Notes', accessor: 'notes',sortable:false },
        {Header:'', Cell:(row)=>  {return this.deleteFormat(row)}}
      ]
      const defaultSort=[{id: "id", desc: true}]

      return <div>
      <section className="small">
      </section>
      <div className="row">
        <div className="col-sm-12">
          <div className="table-responsive">
            <ReactTable defaultSorted={defaultSort}
              noDataText="No Payments Found."
                columns={columns} manual data={data} showPagination={false}
                pages={pages} loading={loading} onFetchData={this.fetchData} minRows={5} defaultPageSize={20} />
          </div>

        </div>
      </div>

      </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/purchase/payment.js